const routers = [
    {path: '/', component: () => import('@/components/HomePage')},
    {path: '/product', component: () => import('@/components/product/Product')},
    {path: '/Operation', component: () => import('@/components/operation/Operation')},
    {path: '/company', component: () => import('@/components/company/Head')},
    {path: '/SmallClass', component: () => import('@/components/SmallClass/SmallClass')},
    {path: '/Warranty', component: () => import('@/components/Warranty/Warranty')},
]

export default routers